<script>
import { Doughnut } from "vue-chartjs";
import ChartJSPluginDoughnutLabel from "chartjs-plugin-doughnutlabel";

export default {
  extends: Doughnut,
  // mixins: [mixins.reactiveProp],
  props: {
    num: {
      type: Number,
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        events: [],
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        elements: {
          arc: {
            backgroundColor: () => {
              if (this.dark) {
                return ["#0091ff", "#ffffff"];
              } else {
                return ["#0091ff", "#CFD2D3"];
              }
            },
            borderWidth: 0
          }
        },
        cutoutPercentage: 67,
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: `${this.num}%`,
                // text: "test",
                font: {
                  size: "16",
                  weight: 700
                },
                color: () => {
                  if (this.dark) {
                    return "#FFFFFF";
                  } else {
                    return "#000000";
                  }
                }
              }
            ]
          }
        }
      }
    };
  },
  computed: {
    pieData() {
      const number = this.num;
      const remainder = 100 - number;
      return {
        datasets: [
          {
            data: [number, remainder]
          }
        ]
      };
    },
    label() {
      return `${this.num}%`;
    }
  },
  mounted() {
    this.addPlugin(ChartJSPluginDoughnutLabel);
    this.renderChart(this.pieData, this.options);
  }
};
</script>
